(() => {
  const start = () => {
    document.querySelectorAll('[data-elemi-scent-rotator]').forEach((hero) => {
      const slides = [...hero.querySelectorAll('.elemi-hero-slide')];
      if (slides.length < 2) return;
      const title = hero.querySelector('[data-scent-title]');
      const number = hero.querySelector('[data-scent-number]');
      const link = hero.querySelector('[data-scent-link]');
      const interval = Number(hero.dataset.interval) || 10000;
      let active = 0;
      const show = (next) => {
        const current = slides[active];
        const incoming = slides[next];
        hero.classList.add('is-dimming');
        window.setTimeout(() => {
          current.classList.remove('is-active');
          incoming.classList.add('is-active');
          active = next;
          if (title) title.textContent = incoming.dataset.title || 'Elemi geurcollectie';
          if (number) number.textContent = String(incoming.dataset.index || next + 1).padStart(2, '0');
          if (link && incoming.dataset.url) link.href = incoming.dataset.url;
          hero.classList.remove('is-dimming');
        }, 900);
      };
      window.setInterval(() => show((active + 1) % slides.length), interval);
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
